<template>
  <v-col cols="12" :sm="embedded || client.show_carousel ? 12 : 6" :lg="embedded || client.show_carousel ? 12 : 4"
         class="card" :class="{ addPadding: layers.includes(layer.id) && !card.image, 'featured-card': featured }"
         :data-card-title="card.title" :data-card-layer="layer.title" :data-card-type="card.type"
         :data-card-subtype="card.subtype" v-observe-visibility="{ callback: visibilityChanged, once: true }">
    <v-card :class="`mx-auto data-caid-${card.id}`" :height="embedded ? '100%' : ''" :data-caid="card.id">
      <div class="card-layer-title" :style="{ 'background-color': layer.icon_font_color + ' !important' }"
           v-if="layers.includes(layer.id) && !client.show_carousel">
        <img v-if="layer.icon && !layer.icon_font" :src="$imgUrl(layer.icon)"/>

        <i v-if="layer.icon_font" class="card-fa" :class="layer.icon_font"></i>

        <span v-html="featured ? __('featured_card', 'Utvald') : layer.__title"></span>
      </div>
      <div v-if="layer.shuffle_cards" @click="shuffleCards(layer)" class="card-shuffle-btn">
        <i class="icon-refresh"></i>
      </div>
      <div :class="client.show_carousel && card.image">
        <template v-if="card.type !== 'youtube'">
          <!-- <v-img v-if="card.image" class="card-top-image"
            src="https://www.adobe.com/creativecloud/photography/discover/media_131179edca5f92db203e2b78cb8a308605afbc958.png?width=750&format=png&optimize=medium"
            :alt="card.image_alt" :height="embedded ? '100%' : '200px'" /> -->
          <v-img v-if="card.image" class="card-top-image" :src="$imgUrl(card.image)" :alt="card.image_alt"
                 :height="embedded ? '100%' : '200px'"/>

          <p class="card-top-image-credits" v-if="card.image_credit" v-html="card.image_credit">
            {{ card.image_credit }}
          </p>
        </template>

        <template v-if="card.type === 'youtube'">
          <div class="card-youtube-thumb" @click="startYoutube()">
            <v-img v-if="card.image" class="card-top-image" :src="$imgUrl(card.image)" :alt="card.image_alt"
                   height="200px"/>

            <v-img v-if="!card.image && youtubeId"
                   :src="'https://img.youtube.com/vi/' + youtubeId + '/hqdefault.jpg'" height="200px"/>

            <v-btn color="#19A0C6" dark absolute bottom right fab>
              <img src="@/assets/img/play.png" width="25">
            </v-btn>
          </div>
        </template>
      </div>
      <div v-if="!loadingData && card.type === 'metric' && chartData">
        <div class="card-metric">
          <Pie :options="chartOptions" :data="{
						...chartData,
						labels: chartData.labels.map((l) => $processText(l)),
						datasets: chartData.datasets.map((d) => ({
							...d,
							label: card.type_options.metric_label ? $processText(card.type_options.metric_label) : '%',
						}))
					}" v-if="card.type_options.chart_type === 'pie'"/>
          <Doughnut :options="chartOptions" :data="{
						...chartData,
						labels: chartData.labels.map((l) => $processText(l)),
						datasets: chartData.datasets.map((d) => ({
							...d,
							label: card.type_options.metric_label ? $processText(card.type_options.metric_label) : '%',
						}))
					}" v-else-if="card.type_options.chart_type === 'doughnut'"/>
          <Bar class="card-metric-bar-chart" :options="chartOptions" :data="{
						...chartData,
						labels: chartData.labels.map((l) => $processText(l)),
						datasets: chartData.datasets.map((d) => ({
							...d,
							label: card.type_options.metric_label ? $processText(card.type_options.metric_label) : '%',
						}))
					}" v-else-if="card.type_options.chart_type === 'bar_horizontal'"/>
          <Bar class="card-metric-bar-chart" :options="{
						...chartOptions,
						indexAxis: 'y',
					}" :data="{
						...chartData,
						labels: chartData.labels.map((l) => $processText(l)),
						datasets: chartData.datasets.map((d) => ({
							...d,
							label: card.type_options.metric_label ? $processText(card.type_options.metric_label) : '%',
						}))
					}" v-else-if="card.type_options.chart_type === 'bar_vertical'"/>
        </div>
      </div>
      <div v-if="!loadingData && card.type === 'metric' && chartData">
        <v-card-title>{{ $processText(card.title) }}</v-card-title>

        <v-card-text v-html="renderedHtml"/>
        <div class="card-cta-container" v-if="card.type_options && card.type_options.cta_btn_text">
          <div class="card-cta-btn">
            <v-btn block large depressed color="primary" @click="ctaClick()">{{
                $processText(card.type_options.cta_btn_text)
              }}
            </v-btn>
          </div>
        </div>
      </div>
      <div>
        <template v-if="card.type === 'regular'">
          <v-card-title>{{ $processText(card.title) }}</v-card-title>

          <v-card-text v-html="$processText(card.wysiwyg)"/>
          <div class="card-cta-container" v-if="card.type_options && card.type_options.cta_btn_text">
            <div class="card-cta-btn">
              <v-btn block large depressed color="primary" @click="ctaClick()">{{
                  $processText(card.type_options.cta_btn_text)
                }}
              </v-btn>
            </div>
          </div>
        </template>


        <template v-if="card.type === 'quiz'">
          <Quiz :card="card"/>
        </template>


        <template v-if="card.type === 'challenge'">
          <Challenge :card="card"/>
        </template>


        <template v-if="card.type === 'calculator'">
          <v-card-title>{{ $processText(card.title) }}</v-card-title>

          <v-card-text>
            <div v-html="$processText(card.wysiwyg)"></div>
            <Calculator :card="card" :processText="$processText"/>
          </v-card-text>
        </template>


        <template v-if="card.type === 'youtube'">
          <v-card-title>
            {{ $processText(card.title) }}
          </v-card-title>

          <v-card-text v-html="$processText(card.wysiwyg)"/>

          <v-dialog v-model="youtubeOpen" width="'95%'" max-width="900" scrollable
                    class="card-youtube-dialog dialog" @click:outside="closeDialog()" @keydown.esc="closeDialog()">
            <v-card>
              <v-card-title class="card-dialog-title">
                <div>{{ $processText(card.title) }}</div>

                <div @click="closeDialog()" class="card-dialog-close"><i class="fa fa-times"></i>
                </div>
              </v-card-title>

              <v-card-text>
                <div class="video-responsive" v-if="card.type_options.youtube_url">
                  <youtube :video-id="youtubeId" :playerVars="{ autoplay: 1 }" ref="youtube">
                  </youtube>
                </div>

                <div v-if="card.type_options.raw_html_video_embed">
                  <div v-html="card.type_options.raw_html_video_embed"></div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </template>


        <template v-if="card.type === 'poll'">
          <Poll :card="card"/>
        </template>


        <template v-if="card.type === 'input'">
          <v-card-title>{{ $processText(card.title) }}</v-card-title>

          <v-card-text v-html="$processText(card.wysiwyg)"/>

          <div class="mx-4 mt-3" v-if="!sent">
            <div class="mb-3">
              <v-text-field hide-details v-model="input.email" outlined
                            label="E-mail (om du vill få svar)"></v-text-field>
            </div>

            <div class="mb-3">
              <v-textarea hide-details v-model="input.feedback" rows="4" outlined
                          label="Idé / Råd / Fråga"/>
            </div>

            <div class="pb-5">
              <v-btn block large depressed color="primary" @click="postInput()">Skicka in</v-btn>
            </div>
          </div>

          <div class="mx-4 py-7 text-center" v-if="sent">
            <h3 v-html="__('poll_thanks')"></h3>
          </div>
        </template>


        <template v-if="card.type === 'accordion'">
          <v-card-title>{{ $processText(card.title) }}</v-card-title>

          <v-card-text v-html="$processText(card.wysiwyg)"/>

          <div class="mx-4 py-4 pt-3">
            <v-btn block large depressed color="primary" @click="toggleDrawer()"
                   v-html="__('button_read_more')"></v-btn>
          </div>

          <v-navigation-drawer class="card-accordion" width="85%" v-model="open" app right fixed temporary
                               overlay-opacity="0">
            <div class="ma-3 ma-md-8 card-accordion-content">
              <h2 class="mb-1">{{ $processText(card.type_options.accordion_title) }}</h2>

              <div v-html="$processText(card.type_options.accordion_wysiwyg)"></div>
            </div>
          </v-navigation-drawer>
        </template>


        <template v-if="card.type === 'onskelinjen'">
          <v-card-title>{{ $processText(card.title) }}</v-card-title>

          <v-card-text>
            <div v-html="$processText(card.wysiwyg)"></div>

            <div class="text-right mt-5">
              <div class="btn generic btn-onskelinjen" @click="openOnskelinjen()">{{
                  card.type_options.iframe_btn || __('iframe_btn') || 'Öppna'
                }}
              </div>
              <p class="onskelinjen-below-btn">Du stannar kvar på denna sida.</p>
            </div>
          </v-card-text>

          <v-dialog v-model="onskelinjenOpen" width="'100%'" max-width="900" scrollable class="dialog"
                    @click:outside="closeDialog()" @keydown.esc="closeDialog()">

            <v-card>
              <v-card-title class="card-dialog-title">
                <div>Önskelinjen</div>

                <div @click="closeDialog()" class="card-dialog-close">
                  <img src="@/assets/img/clear.png" width="20">
                </div>
              </v-card-title>

              <v-card-text>
                <iframe width="100%" class="onskelinjen-iframe" frameborder="0"
                        :src="card.type_options.iframe_url"></iframe>
              </v-card-text>
            </v-card>

          </v-dialog>
        </template>
      </div>
    </v-card>
  </v-col>
</template>

<script>
import axios from 'axios'
import Quiz from '@/components/Quiz'
import Challenge from '@/components/Challenge'
import Calculator from '@/components/Calculator'
import Poll from '@/components/Poll'
import {Pie, Doughnut, Bar} from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  BarElement,
  LinearScale,
  Colors
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, CategoryScale, ArcElement, LinearScale, BarElement, Colors)

export default {
  name: 'Card',
  props: ['card', 'layer', 'featured', 'embedded', 'shuffleCards'],
  components: {Quiz, Challenge, Calculator, Poll, Pie, Doughnut, Bar},

  data() {
    return {
      chartData: null,
      renderedHtml: null,
      chartOptions: {
        responsive: true
      },
      loadingData: true,
      input: {
        email: null,
        feedback: null,
      },

      sent: false,
      open: false,
      youtubeOpen: false,
      onskelinjenOpen: false,
      rawSurveyResponses: [],
    }
  },
  methods: {
    ctaClick() {
      if (this.card.type_options.cta_btn_link) {
        this.$metric({
          'event': 'external_link_interaction',
          'CardTitle': this.card.title,
          'LinkHref': this.card.type_options.cta_btn_link
        }, true)
        window.open(this.card.type_options.cta_btn_link, '_blank')
      }
    },
    fetchMetrics() {
      const ids = this.card.type_options.connected_card_id.split(',').map(id => id.trim());
      const metricAnswerKeys = this.card.type_options.metric_answer_keys
          .split('\n')
          .map(k => k.trim())
          .filter(Boolean);

      console.log('[fetchMetrics] Client ID:', this.client.id);
      console.log('[fetchMetrics] Connected Card IDs:', ids);
      console.log('[fetchMetrics] Metric Answer Keys:', metricAnswerKeys);

      // Check if the client_id 56 or 58, fetch specific user response values
      if ([56, 58].includes(this.client.id)) {
        Promise.all(ids.map(id => axios.get(`${this.$apiUrl}/api/survey/responses?cardId=${id}&clientId=${this.client.id}&userId=${this.endUser.id}`)))
            .then(responses => {
              console.log('[fetchMetrics] API Responses:', responses);
              this.rawSurveyResponses = responses.flatMap(res => res.data);
              this.$store.commit('setSurveyResponses', this.rawSurveyResponses);

              const mergedData = metricAnswerKeys.reduce((acc, curr) => {
                const [key, answerKey] = curr.split(':').map(k => k.trim());
                let value = 0;

                responses.forEach(res => {
                  console.log(`[fetchMetrics] Response data for card:`, res.data);
                  res.data.forEach(resp => {
                    if (resp.response && resp.response[answerKey] !== undefined) {
                      value += Number(resp.response[answerKey]);
                      console.log(`[fetchMetrics] Adding ${resp.response[answerKey]} to ${key}`);
                    }
                  });
                });

                console.log(`[fetchMetrics] ${key} → ${value}`);
                acc[key] = value;
                return acc;
              }, {});

              console.log('[fetchMetrics] Final chartData object:', mergedData);

              this.chartData = {
                labels: Object.keys(mergedData),
                datasets: [{
                  data: Object.values(mergedData).map(value => Number(value).toFixed(1))
                }]
              };
              console.log('[fetchMetrics] chartData set:', this.chartData);
            })
            .catch(error => {
              console.error('[fetchMetrics] ERROR fetching user-specific metric data:', error);
            })
            .finally(() => {
              this.loadingData = false;
            });
      } else {
        // Original summary fetching for other clients
        Promise.all(ids.map(id => axios.get(`${this.$apiUrl}/api/survey/response/${id}/summary`)))
            .then(responses => {
              const mergedData = metricAnswerKeys.reduce((acc, curr) => {
                const [key, group] = curr.split(':').map(k => k.trim());
                const value = responses.reduce((total, res) => total + (res.data[group] || 0), 0);
                acc[key] = value;
                return acc;
              }, {});

              this.chartData = {
                labels: Object.keys(mergedData),
                datasets: [{
                  data: Object.values(mergedData).map(value => Number(value).toFixed(1))
                }]
              };
            })
            .catch(error => {
              console.error("Error fetching metric data:", error);
            })
            .finally(() => {
              this.loadingData = false;
            });
      }
    },
    startYoutube() {
      this.youtubeOpen = true

      if (this.$refs.youtube) {
        this.$refs.youtube.player.playVideo()
      }

      this.$metric({'event': 'modal_opened', 'ModalTitle': this.card.title, 'ModalCategory': 'YouTube Modal'})

    },

    openOnskelinjen() {
      this.onskelinjenOpen = true

      this.$metric({'event': 'modal_opened', 'ModalTitle': this.card.title, 'ModalCategory': 'Önskelinjen'})
    },

    closeDialog() {
      this.youtubeOpen = false
      this.onskelinjenOpen = false

      if (this.$refs.youtube) {
        this.$refs.youtube.player.stopVideo()
      }
    },

    toggleDrawer() {
      this.open = !this.open

      if (this.open) {
        this.$metric({'event': 'modal_opened', 'ModalTitle': this.card.title, 'ModalCategory': 'Accordion'})
      }
    },

    maybeIconColor() {
      if (this.layer.icon_font && this.layer.icon_font_color) {
        return {color: this.layer.icon_font_color + ' !important'}
      }
    },

    visibilityChanged(value) {
      if (value) {
        this.$metric({'event': 'card_viewed', 'CardTitle': this.card.title})
      }
    },

    postInput() {
      axios
          .post(this.$apiUrl + '/api/feedback/' + this.$route.params.slug + '/' + this.card.id, {
            feedback: {
              email: this.input.email,
              feedback: this.input.feedback
            }
          })
          .then(res => this.sent = true)
    }
  },

  computed: {
    endUser() {
      return this.$store.state.endUser
    },

    client() {
      return this.$store.state.client
    },

    youtubeId() {
      let url = this.card.type_options.youtube_url
      let ID = null

      url = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/)

      if (url[2] !== undefined) {
        ID = url[2].split(/[^0-9a-z_-]/i)
        ID = ID[0]
      } else {
        ID = url
      }

      return ID
    },

    layers() {
      return this.$store.getters.translatedLayers
          .filter(l => l.show_in_menu)
          .map(l => l.id)
    },
  },
  watch: {
    'card.type': function (newVal, oldVal) {
      if (newVal === 'metric') {
        this.fetchMetrics()
      }
    }
  },
  async mounted() {
    if (this.card && this.card.type === 'metric') {
      this.fetchMetrics()
    } else {
      this.loadingData = false
    }
    const processed = await this.$processAsyncText(this.card.wysiwyg);
    this.renderedHtml = this.$processText(processed);
  },
}
</script>
